var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item d-flex flex-column align-items-center"},[_c('img',{attrs:{"src":_vm.icon}}),_c('p',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }